import React, { useEffect, useRef, useState } from 'react';

const Typewriter = ({ script, speed = 65, startDelay = 400, noAnimation, onDone }) => {

  const [n, setN] = useState(0);
  const total = script.reduce((s, seg) => s + (seg.t ? seg.t.length : 0), 0);
  const onDoneRef = useRef(onDone);
  onDoneRef.current = onDone;

  useEffect(() => {
    if (noAnimation) {
      setN(total);
      if (onDoneRef.current) onDoneRef.current();
      return;
    }
    let char = 0;
    let interval = null;
    const timeout = setTimeout(() => {
      interval = setInterval(() => {
        char += 1;
        setN(char);
        if (char >= total) {
          clearInterval(interval);
          if (onDoneRef.current) onDoneRef.current();
        }
      }, speed);
    }, startDelay);
    return () => {
      clearTimeout(timeout);
      if (interval) clearInterval(interval);
    };
  }, [total, noAnimation, speed, startDelay]);

  const caret = (
    <span className={n >= total ? 'tw-caret done' : 'tw-caret'} aria-hidden="true"></span>
  );

  const nodes = [];
  let textPos = 0;
  let caretPlaced = false;

  script.forEach((seg, i) => {
    if (seg.br) {
      if (n >= textPos) {
        nodes.push(<br key={'br' + i} />);
      }
      return;
    }
    const start = textPos;
    textPos += seg.t.length;

    if (caretPlaced) {
      return;
    }

    const offset = Math.max(0, Math.min(n - start, seg.t.length));
    const rendered = seg.t.slice(0, offset);
    let content;
    if (n >= start && n <= start + seg.t.length) {
      content = (
        <>
          {rendered}
          {caret}
        </>
      );
      caretPlaced = true;
    } else {
      content = rendered;
    }

    if (seg.spans) {
      nodes.push(<span className="green-easy" key={i}>{content}</span>);
    } else {
      nodes.push(<React.Fragment key={i}>{content}</React.Fragment>);
    }
  });

  if (!caretPlaced) {
    nodes.push(caret);
  }

  return <span>{nodes}</span>;
};

export default Typewriter;